import { useEffect } from 'react'

const PIXEL_ID = '2095498077846022'

/**
 * Installs the Meta Pixel base code and fires a PageView once.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    if (typeof window === 'undefined') return

    if (!window.fbq) {
      const queue: unknown[][] = []
      const fbq = function (...args: unknown[]) {
        const self = fbq as unknown as {
          callMethod?: (...a: unknown[]) => void
          queue: unknown[][]
        }
        if (self.callMethod) {
          self.callMethod.apply(self, args)
        } else {
          self.queue.push(args)
        }
      } as unknown as Window['fbq'] & { queue: unknown[][]; loaded: boolean; version: string }

      fbq.queue = queue
      fbq.loaded = true
      fbq.version = '2.0'
      window.fbq = fbq as unknown as Window['fbq']
      ;(window as unknown as Record<string, unknown>)._fbq = window.fbq

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)
    }

    window.fbq?.('init', PIXEL_ID)
    window.fbq?.('track', 'PageView')

    if (!document.getElementById('meta-pixel-noscript')) {
      const noscript = document.createElement('noscript')
      noscript.id = 'meta-pixel-noscript'
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1" alt="" />`
      document.body.appendChild(noscript)
    }
  }, [])
}
